import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import { useCreateOptIn } from "../../cspServices";
import { lensProp, set } from "ramda";
import { notBlank } from "../../../util/ext";
import ErrorMessage from "../../../components/alert/ErrorMessage";
import SaveButton from "../../../components/SaveButton";
import OptInForm, { validateOptIn, validateOptInField } from "./OptInForm";

const initialOptIn = {
  optInName: "",
  optInTitle: "",
  optInDescription: "",
  acceptTitle: "",
  acceptDescription: "",
  declineTitle: "",
  declineDescription: "",
  regional: false,
  termsUri: "",
  logoUri: "",
};

const NewOptInDialog = ({ open, onClose }) => {
  const createOptIn = useCreateOptIn();

  const [optIn, setOptIn] = useState(initialOptIn);
  const [errors, setErrors] = useState({});

  const handleChange = prop => event => {
    const value = event.target.value;
    setOptIn(set(lensProp(prop), value));
  };

  const handleCheckbox = prop => event => {
    const checked = event.target.checked;
    setOptIn(set(lensProp(prop), checked));
  };

  const handleBlur = (prop, value) => () =>
    setErrors(validateOptInField(prop, value));

  const handleSave = async () => {
    const validation = validateOptIn(optIn);
    try {
      if (notBlank(validation)) {
        setErrors(validation);
        throw Error("Please correct issues before saving");
      }

      await createOptIn.mutateAsync({
        data: optIn,
      });

      onClose();
    } catch (err) {
      setErrors(set(lensProp("main"), err));
    }
  };

  return (
    <Dialog open={open} aria-labelledby="new-opt-in-dialog">
      <DialogTitle id="new-opt-in-dialog">Create an Opt-In</DialogTitle>
      {errors.main && (
        <Grid container justifyContent="center">
          <ErrorMessage error={errors.main} />
        </Grid>
      )}
      <DialogContent>
        <OptInForm
          optIn={optIn}
          errors={errors}
          handleBlur={handleBlur}
          handleChange={handleChange}
          handleCheckbox={handleCheckbox}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <SaveButton onClick={handleSave} loading={createOptIn.isPending}>
          Create
        </SaveButton>
      </DialogActions>
    </Dialog>
  );
};

export default NewOptInDialog;
